import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin, FiSend } from 'react-icons/fi';
import './CoachifyPages.css';
import CoachifyLogo from '../../assets/logos/CoachifyHoriLogo.png';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    gymName: '',
    phone: '',
    message: '',
    interest: 'demo'
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In production, this would send to an API endpoint
    console.log('Form submitted:', formData);
    setSubmitted(true);
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        gymName: '',
        phone: '',
        message: '',
        interest: 'demo'
      });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="coachify-page">
      {/* Header Navigation */}
      <header className="coachify-header">
        <div className="header-logo">
          <Link to="/" className="logo-link">
            <img src={CoachifyLogo} alt="Coachify" className="header-logo-img" />
          </Link>
        </div>
        <nav className="coachify-nav">
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/features" className="nav-link">Features</Link>
          <Link to="/pricing" className="nav-link">Pricing</Link>
          <Link to="/contact" className="nav-link active">Contact</Link>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-container">
          <h1 className="page-title">Let's Transform Your Gym Together</h1>
          <p className="page-subtitle">
            Schedule a demo, ask questions, or start your free trial. We're here to help.
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="page-content">
        <div className="page-container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-section">
              <h2 className="section-title">Get in Touch</h2>
              {submitted ? (
                <div className="success-message">
                  <FiSend className="success-icon" />
                  <h3>Thank you for reaching out!</h3>
                  <p>We'll get back to you within 24 hours.</p>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Your Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="John Smith"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="john@yourgym.com"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="gymName">Gym Name *</label>
                      <input
                        type="text"
                        id="gymName"
                        name="gymName"
                        value={formData.gymName}
                        onChange={handleChange}
                        required
                        placeholder="Your Gym Name"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="+1 (555) 123-4567"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="interest">I'm Interested In *</label>
                    <select
                      id="interest"
                      name="interest"
                      value={formData.interest}
                      onChange={handleChange}
                      required
                    >
                      <option value="demo">Scheduling a Demo</option>
                      <option value="trial">Starting a Free Trial</option>
                      <option value="pricing">Pricing Information</option>
                      <option value="enterprise">Enterprise Solutions</option>
                      <option value="other">General Inquiry</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder="Tell us about your gym and what you're looking for..."
                    ></textarea>
                  </div>

                  <button type="submit" className="submit-button">
                    <FiSend />
                    Send Message
                  </button>
                </form>
              )}
            </div>

            {/* Contact Info */}
            <div className="contact-info-section">
              <h2 className="section-title">Other Ways to Reach Us</h2>

              <div className="info-cards">
                <div className="info-card">
                  <div className="info-icon">
                    <FiMail />
                  </div>
                  <h3 className="info-title">Email</h3>
                  <p className="info-text">hello@coachify.com</p>
                  <p className="info-subtext">We typically respond within 24 hours</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <FiPhone />
                  </div>
                  <h3 className="info-title">Phone</h3>
                  <p className="info-text">+1 (555) 123-4567</p>
                  <p className="info-subtext">Mon-Fri, 9am-6pm EST</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <FiMapPin />
                  </div>
                  <h3 className="info-title">Office</h3>
                  <p className="info-text">123 Fitness Ave, Suite 200</p>
                  <p className="info-subtext">San Francisco, CA 94103</p>
                </div>
              </div>

              <div className="quick-stats">
                <h3 className="stats-title">Why Gyms Choose Coachify</h3>
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Gyms Worldwide</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">50K+</span>
                  <span className="stat-label">Active Clients</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">4.9/5</span>
                  <span className="stat-label">Customer Rating</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="coachify-footer">
        <p>&copy; 2025 Coachify. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Contact;
